import Modal from 'react-bootstrap/Modal';
import Image from 'react-bootstrap/Image';
import New01 from './assets/new01.jpg'
import New02 from './assets/new02.jpg'
import New03 from './assets/new03.jpg'
import New04 from './assets/new04.jpg'
import newDoc from './assets/newModalDoc.pdf'
import { Link } from 'react-router-dom';

export default function NewModal(props) {
    return (
      <Modal size='xl'
        {...props}
        style={{opacity:1}}
        fullscreen='xxl-down'
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            What's New in 2024!
          </Modal.Title>
          <div className='col-7'></div>
          <div>
            <Link  to={newDoc} target='_blank' download="whats-new-2024">
              Click Here to Download
            </Link>
          </div>
        </Modal.Header>
        <Modal.Body>

          <p>
          
            <Image src={New01} fluid />
            <Image src={New02} fluid />
            <Image src={New03} fluid />
            <Image src={New04} fluid />
          </p>
        </Modal.Body>
      </Modal>
    );
  }